import StyleSheet from 'react-native-extended-stylesheet';
import {Dimensions} from 'react-native';

const {width} = Dimensions.get('window');

export const style = StyleSheet.create({
  containerL: {
    flexDirection: 'row',
    height: '95vh',
    width: '100%',
  },
  containerS: {
    marginTop: '$space8',
  },
  image: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  },
  imageMobile: {
    width: '100%',
    height: '100%',
  },
  imageContainer: {
    flex: 1,
  },
  imageContainerMobile: {
    paddingTop: '125%',
    display: 'flex',
  },
  imageContainerNative: {
    height: 1.25 * width,
  },
  detailWrapper: {
    maxWidth: 472,
  },
  detailLayout: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
  },
});
